import { useContext } from 'react';
import { RowContext } from '../contexts/row.context';

export const useRow = () => {
  const context = useContext(RowContext);
  if (context == null) {
    throw new Error('useRow must be used inside <Row>');
  }

  return context;
};
